module.exports = __webpack_public_path__ + "static/logo-aafef2fd58bab2e74846191e1757894c.png";